// for Production:
// export const BASE_URL = "https://portalapi.ncs-portal.org.ng/api";
// export const File_URL = "https://portalapi.ncs-portal.org.ng/";

// For NCS Development
export const BASE_URL = "https://ncsmembersportalapi.vatebra.org/api";
export const File_URL = "https://ncsmembersportalapi.vatebra.org/";
